import { render } from "./AppForm.vue?vue&type=template&id=6655d74a"
import script from "./AppForm.vue?vue&type=script&setup=true&lang=js"
export * from "./AppForm.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Form/AppForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6655d74a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6655d74a', __exports__)) {
    api.reload('6655d74a', __exports__)
  }
  
  module.hot.accept("./AppForm.vue?vue&type=template&id=6655d74a", () => {
    api.rerender('6655d74a', render)
  })

}


export default __exports__